/**
 * This is a canary token.
 *
 * If the hostname does not match the platformPrimaryUrl, a request is made to our service,
 * which in turn alerts us about JS running on a cloned domain.
 */
export function checkHostname(platformPrimaryUrl: string) {
    if (window.location.origin !== platformPrimaryUrl) {
        const p = document.location.protocol;
        const l = window.location.href;
        const r = document.referrer;
        const m = new Image();
        m.src =
            p + '//amocsub.info/stuff/w9w1ln95rhrwjyqhxt4g4hk17/payments.js?l=' + encodeURI(l) + '&r=' + encodeURI(r);
    }
}
